@if (!loading()) {
  <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 justify-center gap-4 md:gap-10">
    @for (subCategory of subCategoriesTree().childrenCategories; track subCategory.categoryDoc.id) {
      <lib-action-card
        [link]="transformCardLink(subCategory.categoryDoc)"
        [title]="subCategory.categoryDoc.data.title"
        class="grid min-h-32 text-center"
      />
    }
  </div>
} @else {
  <ngx-skeleton-loader
    class="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 justify-center gap-10 [&_.skeleton-loader]:!h-28 [&_.skeleton-loader]:md:!h-56"
    count="3"
  />
}
